import styled from 'styled-components';

export const Avatar = styled.div`
  width: 24px;
  height: 24px;
  background: ${(props) => props.theme.$primary_green};
  border: 0;
  border-radius: 4px;
  font-size: 16px;
  font-weight: lighter;
  color: white;
  text-align: center;
`;

export const MarkdownContent = styled.div`
  font-size: 1rem;
  line-height: 1.6;
  p {
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 1.25rem;
  }
  h1,
  h2,
  h3 {
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  ul,
  ol {
    margin-bottom: 1rem;
    padding-left: 25px;
  }
  li {
    margin-bottom: 0.5rem;
  }
  strong {
    font-weight: 700;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: 0.9rem;
  }
  th,
  td {
    border: 1px solid #dee2e6;
    padding: 0.75rem;
    text-align: left;
  }
  thead {
    background-color: #f8f9fa;
  }
  thead th {
    font-weight: bold;
  }
  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

export const MessageActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 8px;

  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  button {
    background: transparent;
    border: none;
    padding: 4px;
    cursor: pointer;
  }
`;
